import React, { Component } from "react";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import * as appConst from "../../Common/constants";
import { isNull } from "util";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

export default class Tracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerClass: "collapse",
      dataClass: "",
      nameSuggestions: null,
      nameList: [],
      medList: [],
      stock: 0,
      qty: 0,
      mno: "",
      name: this.props.name,
      eno: this.props.eno,
      patientNameSuggestions: null,
      patientNameList: [],
      patient: "",
      txndate: "",
      tracker: [],
      trackerClass: "collapse"
    };

    this.handleTxnDateChange = this.handleTxnDateChange.bind(this);
    this.onReturnClick = this.onReturnClick.bind(this);
  }

  componentDidMount() {
    this.LoadNames();
    this.LoadPatients();

    if (this.state.eno !== "") {
      this.LoadStock(this.state.eno);
      this.LoadTracker(this.state.eno);
    }
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/getNames"
      )
      .then(response => {
        this.setState({ medList: response.data });
        let nameData = response.data;
        nameData.forEach(function(item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  LoadPatients() {
    let _patientNameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/patient/getAllNames"
      )
      .then(response => {
        let nameData = response.data;
        nameData.forEach(function(item) {
          _patientNameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ patientNameList: _patientNameList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  suggestPatientName(event) {
    let results = this.state.patientNameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ patientNameSuggestions: results });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <div>
        <div>
          <h5 align="center">Equipment Tracker</h5>
        </div>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Equipment</div>
            <div className="col col-md-8">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
                className="p-error"
              />
              <div className="text-danger font-weight-bold">
                Stock : {this.state.stock}
              </div>
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Patient</div>
            <div className="col col-md-8">
              <AutoComplete
                value={this.state.patient}
                onChange={this.onPatientNameChange}
                suggestions={this.state.patientNameSuggestions}
                completeMethod={this.suggestPatientName.bind(this)}
                size={38}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Quantity</div>
            <div className="col col-md-4">
              <InputText
                type="text"
                keyfilter="pint"
                value={this.state.qty}
                onChange={e => this.setState({ qty: e.target.value })}
                style={{ width: "300px" }}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Txn Date</div>
            <div className="col col-md-4">
              <DatePicker
                selected={this.state.txndate}
                onChange={this.handleTxnDateChange}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 10)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
                // style={{ width: "300px" }}
                className="p-error"
              />
            </div>
          </div>

          <div className="row p-1 border">
            <div className="col col-md-4">
              <button
                onClick={this.onTransferClick}
                className="btn btn-primary btn-md mr-2"
              >
                Submit
              </button>
            </div>
          </div>
          <Growl ref={el => (this.growl = el)} />
          <Messages ref={el => (this.messages = el)} />

          <div className="row p-1 border header">
            <div className="col col-md-12" align="center">
              <h4>Equipment Tracker</h4>
            </div>
          </div>

          <div className={this.state.trackerClass}>
            <div
              className="col col-md-12 ag-theme-blue"
              style={this.getHeight()}
            >
              <AgGridReact
                rowData={this.state.tracker}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
              >
                <AgGridColumn field="_id" hide="true" />
                <AgGridColumn
                  field="patientname"
                  headerName="Patient"
                  width={374}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="qty"
                  headerName="Quantity"
                  width={130}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="outdate"
                  headerName="Out Date"
                  width={130}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.dateFormatter}
                />
                <AgGridColumn
                  width={130}
                  headerName="Return"
                  cellRendererFramework={this.renderButton}
                />
              </AgGridReact>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleTxnDateChange(txndate) {
    this.setState({ txndate });
  }

  onPatientNameChange = e => {
    this.setState({ patient: e.value });
  };

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  renderButton = params => {
    return (
      <p>
        <a
          onClick={this.onReturnClick}
          className="text-primary"
          data={JSON.stringify(params.data)}
        >
          Click Here
        </a>
      </p>
    );
  };

  onNameSelect = e => {
    let results = this.state.medList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    this.setState({ eno: results.eno, name: results.name });

    this.LoadStock(results.eno);
    this.LoadTracker(results.eno);
  };

  LoadTracker(eno) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/tracker/" +
          eno
      )
      .then(response => {
        this.setState({
          tracker: response.data,
          trackerClass: "row p-1 border"
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  LoadStock(eno) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/getStock/" +
          eno
      )
      .then(response => {
        this.setState({
          stock: isNull(response.data.stock.stock)
            ? 0
            : response.data.stock.stock
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  onNameChange = e => {
    this.setState({
      name: e.value,
      stock: 0,
      qty: 0,
      patient: "",
      txndate: "",
      tracker: [],
      trackerClass: "collapse"
    });
  };

  onTransferClick = async e => {
    e.preventDefault();

    if (
      this.state.qty <= this.state.stock &&
      this.state.qty > 0 &&
      this.state.name !== "" &&
      this.state.patient !== "" &&
      this.state.txndate !== ""
    ) {
      const obj = {
        eno: this.state.eno,
        qty: this.state.qty,
        patientname: this.state.patient,
        outdate: this.state.txndate
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
            
            "/equipment/transfer",
          obj
        )
        .then(res => {
          this.ClearData();
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Equipment Transferred !!!"
          });
          this.LoadNames();
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });
    } else {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input !!"
      });
    }
  };

  onReturnClick = async e => {
    this.props.onClick(
      "AddEdit",
      JSON.parse(e.target.getAttribute("data")),
      this.state.name,
      this.state.eno
    );
  };

  ClearData() {
    this.setState({
      name: "",
      stock: 0,
      qty: 0,
      patient: "",
      txndate: "",
      tracker: [],
      trackerClass: "collapse"
    });
  }

  onCancelClick = e => {
    this.ClearData();
  };
}
